import { PAGE_LIMIT_MAX } from "@alm/domain";

/** The page size in the URL, kept within what the fax list serves so a typed value never fails. */
export function faxPageSize(value: unknown): number | undefined {
  const size = Math.floor(Number(value));
  return size >= 1 ? Math.min(size, PAGE_LIMIT_MAX) : undefined;
}
